<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="p-2">
      <TitleButton
          btnTitle="Add New"
          :showBtn="false"
          :showAddNew="!metaData.is_shareholder"
          @onClickAddNewButton="openModal"
      />
    </div>

    <div
        v-for="master in tableItems"
        :key="master.id"
        class="card px-2 mb-1" style="min-height: 200px"
    >
      <div class="card-header d-flex justify-content-between align-items-center">
        <div>
          <strong>{{ master.project_name }}</strong>
          <small>
            ({{ master.start_date }} → {{ master.end_date }})
          </small>
        </div>

        <button v-if="false"
            class="btn btn-sm btn-outline-primary"
        >
          Edit
        </button>
      </div>

      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table mb-0 table-bordered">
            <thead class="table-light">
            <tr>
              <th>Payment Type</th>
              <th>Schedule Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="general in master.generals"
                :key="general.id"
            >
              <td>{{ general.title }}</td>
              <td>{{ general.date }}</td>
              <td>{{ general.amount }}</td>
              <td>
            <span
                :class="[
                'badge text-capitalize',
                general.status === 'due'
                  ? 'bg-warning'
                  : 'bg-success'
              ]"
            >
              {{ general.status }}
            </span>
              </td>
              <td>
                <button v-if="general.status === 'due' && !metaData.is_shareholder" @click="openMoneyReceiptModal(general)" class="btn btn-sm btn-outline-primary">
                  Pay Now
                </button>
                <button class="btn btn-secondary btn-sm"
                        @click="goToPrint(general.receipt_master_id)"
                        v-if="general.status === 'paid'"
                        style="cursor: pointer; margin-left: 10px"
                >
                  <i class="fas fa-print"></i>
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>    <div class="mb-2"></div>
    <Loader v-if="loading"/>

    <InstallmentPlanSetupModal
        v-if="isModalOpen"
        :contact="selectedContact"
        @close="closeModal"
        @getData="getBillPaymentData"
    />

    <MoneyReceiptModal
        v-if="isMoneyReceiptModalOpen"
        :contact="selectedContact"
        :generalData="generalData"
        @close="closeMoneyReceiptModal"
        @getData="getBillPaymentData"
    />
  </div>
</template>

<script setup>
import TitleButton from "@/components/atom/TitleButton.vue";
import {ref, watch, inject, onMounted} from "vue";
import Loader from "@/components/atom/LoaderComponent.vue";
import InstallmentPlanSetupModal from "@/views/page/company/procurement/shareholder-register/bill-payment/InstallmentPlanSetupModal.vue";
import MoneyReceiptModal from "@/views/page/company/procurement/shareholder-register/bill-payment/MoneyReceiptModal.vue";
import handleProjects from "@/services/modules/procurement/project";
import handlePurchase from "@/services/modules/purchase";
import handleCompany from "@/services/modules/company";
import moneyReceiptHelper from "@/services/utils/pdf/moneyReceiptHelper";
import {useRoute} from "vue-router";

const loading = ref(false)
const isModalOpen = ref(false)
const isMoneyReceiptModalOpen = ref(false)
const selectedContact = ref(null)
const generalData = ref({})
const tableItems = ref([])
const $route = useRoute();

const props = defineProps({
  contactInfo: {
    type: Object,
    default: {
      full_name: '',
      profile_items: [],
      contact: {},
    }
  },
  contactDetails: {
    type: Array,
    default: []
  },
  metaData: {
    type: Array,
    default: []
  }
})

const showError = inject('showError')
const { getProjectInstallmentSetupData } = handleProjects();
const { fetchMoneyReceipt } = handlePurchase();
const { fetchCompanyInfo } = handleCompany();
const { generatePdf } = moneyReceiptHelper();

const companyInfo = ref({})
const moneyReceipt = ref({})

const getCompanyInfo = async () => {
  const res = await fetchCompanyInfo($route.params.companyId);
  if (!res.status) return;
  companyInfo.value = res.data;
}

const openModal = () => {
    isModalOpen.value = true;
    selectedContact.value = props.contactInfo
}

const openMoneyReceiptModal = (item) => {
  isMoneyReceiptModalOpen.value = true;
  selectedContact.value = props.contactInfo
  generalData.value = item
}

const closeModal = () => {
  isModalOpen.value = false
}

const closeMoneyReceiptModal = () => {
  isMoneyReceiptModalOpen.value = false
}

const goToPrint = (id) => {
  const companyQuery = `?company_id=${$route.params.companyId}`;
  fetchMoneyReceipt(id, companyQuery).then((res) => {
    if (!res.status) return;
    moneyReceipt.value = res.data;
  }).then(() => {
    generatePdf(companyInfo.value, moneyReceipt.value)
  }).catch(() => {
    showError('Something is wrong. Check your connectivity!!')
  })
}

watch(
    () => props.contactInfo,
    (newVal) => {
      if (newVal && newVal.id) {
        getBillPaymentData();
      }
    },
    { immediate: true }
);

const getQuery = () => {
  let query = '?company_id=' + $route.params.companyId
   query += '&contact_profile_id=' + props.contactInfo.id
  return query
};

async function getBillPaymentData() {
  let query = getQuery();
  try {
    const res = await getProjectInstallmentSetupData(query);
    if (!res.status) {
      tableItems.value = [];
    }
    tableItems.value = res.data;
  } catch (err) {

  }
}

onMounted(() => {
  getCompanyInfo();
})
</script>
